<template>
  <div class="demoPage">
    <!-- tab切换 -->
    <div class="navTabs fixed-content">
        <div class="tabs border-bottom-03a9f4 color-appStyle">整体情况</div>
        <div class="tabs" @click="toPage('/floorSituation')">楼栋情况</div>
        <div class="tabs" @click="toPage('/studentRoomMangerTwo')">学院分布表</div>
    </div>
    <div class="mt-content scroll-content">
      <div class="font-size-28 margin-top-20 bold">学生住房比重</div>
      <div class="pieCharts">
        <chart ref="chart1" :options="orgOptions" :auto-resize="true"></chart>
      </div>
      <div class="font-size-28 bold">房间区域分布情况</div>
      <div class="tabContent">
          <div class="grid" style="padding-left: 0;padding-right: 0;">
            <div class="gridWarp bg-appStyle color-fff">
              <div class="gridCell flex-1 bold">区域</div>
              <div class="gridCell flex-1 bold">房间总数</div>
              <div class="gridCell flex-1 bold">已入住</div>
              <div class="gridCell flex-1 bold">空置房</div>
              <div class="gridCell flex-1 bold">破损房</div>
              <div class="gridCell flex-1 bold">入住率</div>
            </div>

            <div v-if="dormAreaList.length > 0">
              <div class="gridWarp bg-fff" v-for="(item, index) in dormAreaList" :key="index">
                <div class="gridCell flex-1" :class="{'bold': item.zoneName == '总计'}">{{item.zoneName}}</div>
                <div class="gridCell flex-1">{{item.allCnt}}</div>
                <div class="gridCell flex-1">{{item.yrzCnt}}</div>
                <div class="gridCell flex-1">{{item.kzfCnt}}</div>
                <div class="gridCell flex-1">{{item.psfCnt}}</div>
                <div class="gridCell flex-1">{{item.rzblStr}}</div>
              </div>
            </div>

          </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import service from "@/fetch/service";
export default {
  data () {
    return {
      orgOptions: {},
      zfbz: [
          { 
            value: 0,
            name:'空置房',
            nameId: 'kzfCnt'
          },
          { 
            value: 0,
            name:'已入住',
            nameId: 'yrzCnt'
          },
          { 
            value: 0,
            name:'破损房',
            nameId: 'psfCnt'
          }
      ],
      zCnt: [
          { 
            value: 0,
            name:'住1',
            nameId: 'z1Cnt', 
            selected:true
          },
          { 
            value: 0, 
            nameId: 'z2Cnt',
            name:'住2'
          },
          { 
            value: 0, 
            nameId: 'z3Cnt',
            name:'住3'
          },
          { 
            value: 0,
            nameId: 'z4Cnt', 
            name:'住4'
          }
      ],
      dormAreaList: []
    }
  },
  created() {
    this.getDatas()
  },
  mounted() {
    let that = this
    this.orgOptions = {
        title : {
            text: '学生住房比重',
            subtext: '学生住房比重',
            x:'center'
        },
        tooltip : {
            trigger: 'item',
            show: true,
            formatter: "{b}<br/> {c} ({d}%)"
        },
        legend: [
            {
              orient: 'horizontal',
              top: '13%',
              left: 'center',
              selected: false,
              textStyle: {
                fontSize: "16px"
              },
              data: ['住1', '住2', '住3', '住4']
            },
            {
              orient: 'horizontal',
              top: '5%',
              left: 'center',
              textStyle: {
                fontSize: "16px"
              },
              data: ['已入住','空置房','破损房']
            }
        ],
        color: ["#4a7b82", "#9dc5b0", "#b34037", "#90e680", "#83c987", "#85b77c", "#72976b"],
        series : [
            {
                name: '学生住房比重',
                type: 'pie',
                radius : ['40%','60%'],
                center: ['50%', '66%'],
                data: this.zfbz,
                selectedMode:false,
                selectedOffset: 2,
                label: {
                  normal: {
                    show: true,
                    fontSize: "16px",
                    color: '#333',
                    position: "outside",
                    formatter: "{b}"+"{d}%"
                  },
                  emphasis: {
                    show: true,
                    fontSize: "16px",
                    color: '#333',
                    position: "outside",
                    formatter: "{b}"+"{d}%"
                  }
                },
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            },
            {
                name:'访问来源',
                type:'pie',
                selectedMode: 'single',
                radius: [0, '30%'],
                center: ['50%', '66%'],
                label: {
                    normal: {
                        position: 'inner',
                        formatter: function (params) {
                          // console.log(params)
                          return params.dataIndex + 1
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: this.zCnt
            }
        ]
    }
  },
  methods: {
    toPage: function(pageName) {
      this.$router.replace(pageName);
    },
    // 请求数据
    getDatas: function() {
      var that = this
      //统计学生住房比重
      service
      .roomZfbz({})
      .then(res => {
        console.log(res)
        if (res.success) {
          let roomCount = res.result.roomCount
          let roomStatus = res.result.roomStatus
          that.zfbz.forEach(element => {
            if (element.nameId == 'kzfCnt') {
              element.value = roomStatus.kzfCnt
            }else if (element.nameId == 'psfCnt') {
              element.value = roomStatus.psfCnt
            }else if (element.nameId == 'yrzCnt') {
              element.value = roomStatus.yrzCnt
            }
          });
          that.zCnt.forEach(element => {
            if (element.nameId == 'z1Cnt') {
              element.value = roomCount.z1Cnt
            }else if (element.nameId == 'z2Cnt') {
              element.value = roomCount.z2Cnt
            }else if (element.nameId == 'z3Cnt') {
              element.value = roomCount.z3Cnt
            }else if (element.nameId == 'z4Cnt') {
              element.value = roomCount.z4Cnt
            }
          });
        }
      })
      .catch(error => {
        console.log(error);
      });

      //统计宿舍楼区域分布情况
      service
      .findDormAreaFbList({})
      .then(res => {
        console.log(res)
        if (res.success) {
          this.dormAreaList = res.result
        }
      })
      .catch(error => {
        console.log(error);
      });

    }
  }
}
</script>
<style lang="scss">
  @import "../assets/css/function";
  html, .demoPage, .mt-content {
    background: #f5f5f5;
  }
  $fixed-height: px2rem(80px);
  .demoPage {
    .navTabs {
      width: 100%;
      height: $fixed-height;
      display: flex;
      flex-flow: row wrap;
      .tabs {
        background: #fff;
        height: $fixed-height;
        line-height: $fixed-height;
        text-align: center;
        box-sizing: border-box;
        flex: 0 0 33.33%;
        font-size: px2rem(30px);
      }
    }
    .mt-content {
      padding: px2rem(36px) px2rem(20px) px2rem(40px) px2rem(20px) !important;
    }
    .fixed-content {
      height: calc(#{$fixed-height}) !important;
    }
    .scroll-content {
      top: calc(#{$fixed-height}) !important;
    }
    .titleItem {
      display: flex;
      justify-content: space-between;
    }
  }
  .pieCharts {
    margin-bottom: px2rem(40px);
  }
  .pieCharts> .echarts {
    width: 100% !important;
    height: 260px !important;
  }
</style>


// WEBPACK FOOTER //
// StudentRoomManger.vue?2cbe0025